import styles from './styles.module.scss';
import { REACT_APP_CONNECT_BASE_URL } from 'config';
import { FC } from 'react';

type Props = {
  contactId: number;
};

export const NewContactIframeModalBody: FC<Props> = ({ contactId }) => {
  return (
    <div>
      <iframe
        className={`${styles.iframe}`}
        src={`${REACT_APP_CONNECT_BASE_URL}/new-contact-iframe/${contactId}`}
      ></iframe>
    </div>
  );
};
